<template>
    <div v-if="!isClosed">
        <div
            v-if="isAccepted"
            class="draftConsultationNotifier draftConsultationAccepted">
            <div class="d-flex justify-content-between align-items-center">
                <div class="draftConsultationNotifierText">
                    <div>{{ $locale.consultation_host }}予約が完了しました</div>
                </div>
                <div
                    @click="close"
                    class="draftConsultationNotifierClose">
                    <img src="/images/consultations/draft-accepted.svg">
                </div>
            </div>
        </div>
        <div
            v-else-if="draftConsultation !== null"
            @click="onClick"
            class="draftConsultationNotifier">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <div class="draftConsultationNotifierImageWrapper">
                        <div class="draftConsultationNotifierImage">
                            <img
                                v-if="draftConsultation.doctor_menu.doctor.presigned_url !== null"
                                :src="draftConsultation.doctor_menu.doctor.presigned_url">
                            <img
                                v-else
                                src="/images/common/profile_default.svg">
                        </div>
                    </div>
                    <div class="draftConsultationNotifierText">
                        <div>{{ `${draftConsultation.doctor_menu.doctor.full_name}医師から` }}</div>
                        <div>{{ `新しい${$locale.consultation_host}予約の依頼が届きました。` }}</div>
                    </div>
                </div>
                <div class="draftConsultationNotifierArrow">
                    <img src="/images/consultations/draft-arrow.svg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            draftConsultation: {
                type: Object | null,
                default: null,
            },
            isAccepted: {
                type: Boolean,
                default: false,
            },
            isClosed: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            /**
             * 通知を閉じる
             */
            close: function () {
                bus.$emit('user-draft-consultation-notifier-closed')
            },

            /**
             * ドラフト予約通知の押下時
             */
            onClick: function () {
                bus.$emit('open-modal-user-draft-consultation-confirm', this.draftConsultation)
            },
        },
    }
</script>

<style lang="scss" scoped>
.draftConsultationNotifier {
    position: absolute;
    left: 50%;
    bottom: 15px;
    transform: translate3d(-50%, 0, 0);
    width: 80%;
    padding: 15px 20px;
    text-align: left;
    background: rgba(255, 109, 149, 0.8);
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;

    &:hover {
        background: rgba(255, 109, 149, 0.9);
    }

    &.draftConsultationAccepted {
        cursor: default;
        background: rgba(0, 190, 195, 0.8);

        &:hover {
            background: rgba(0, 190, 195, 0.9);
        }
    }

    .draftConsultationNotifierImageWrapper {
        position: relative;

        .draftConsultationNotifierImage {
            position: relative;
            overflow: hidden;
            width: 50px;
            min-width: 50px;
            height: 50px;
            border-radius: 50%;

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
    }

    .draftConsultationNotifierText {
        padding-left: 15px;
        color: #fff;
        font-size: 14px;
    }

    .draftConsultationNotifierArrow {
        width: 19px;
        margin-left: 30px;
    }

    .draftConsultationNotifierClose {
        position: relative;
        top: -1px;
        margin-left: 30px;
        cursor: pointer;
    }
}
</style>
